import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Location } from '@angular/common';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

declare const toastr: any;
declare const swal: any

@Component({
    selector: 'app-view-deactivation-request-status',
    templateUrl: './view-deactivation-request-status.component.html',
    styleUrls: ['./view-deactivation-request-status.component.css']
})
export class ViewDeactivationRequestStatusComponent implements OnInit {

    deactivationForm: FormGroup;
    loggedInUser: any;
    deactivationRequests = [];
    isEnabled = true;
    selectedRequest: any;
    isDuplicate = false;
    remarksFromPMU: any = [];
    deactivateUserProfile = false;
    length = 0;
    pageNo = 1;
    itemsPerPage = 10;
    localFileName: { localFile: String, document: String } = { localFile: '', document: '' }


    constructor(
        public location: Location,
        private currentUser: CurrentUserService,
        private totBatchService: TotBatchService,
        private formBuilder: FormBuilder
    ) {
        this.getCurrentUser();
    }

    ngOnInit() {
        this.createDeactivationForm();
        this.getDeactivationRequestStatus();
    }

    getCurrentUser() {
        this.currentUser.getCurrentUser().subscribe(res => {
            this.loggedInUser = res;
        })
    }

    getDeactivationRequestStatus() {
        const role = this.loggedInUser.role.toLowerCase();
        this.totBatchService.getDeactivationRequestStatusForApplicant(role).subscribe(res => {
            console.log(res);
            this.deactivationRequests = res.data;
            this.length = res.count;
        })
    }

    createDeactivationForm() {
        this.deactivationForm = this.formBuilder.group({
            reason: ['', Validators.required],
            duplicateUserName: [''],
            comment: [''],
            document: ['', [ValidationService.fileValidator,
            ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'),
            ValidationService.fileSizeValidator(5)]]
        })
    }

    selectedReason(event) {
        const reason = this.deactivationForm.get('reason').value;
        console.log(reason);
        if (reason === 'notListed') {
            this.isEnabled = true;
            this.isDuplicate = false;
            this.deactivationForm.get('comment').setValidators([Validators.required]);
            this.deactivationForm.get('comment').updateValueAndValidity();
            this.deactivationForm.get('duplicateUserName').setValue("");
            this.deactivationForm.get('duplicateUserName').setValidators([]);
            this.deactivationForm.get('duplicateUserName').updateValueAndValidity();
        } else if (reason === 'duplicate') {
            this.isDuplicate = true;
            this.isEnabled = false;
            this.deactivationForm.get('comment').setValue("");
            this.deactivationForm.get('comment').setValidators([]);
            this.deactivationForm.get('comment').updateValueAndValidity();
            this.deactivationForm.get('duplicateUserName').setValidators([Validators.required]);
            this.deactivationForm.get('duplicateUserName').updateValueAndValidity();
        } else {
            this.isEnabled = false;
            this.isDuplicate = false;
            this.deactivationForm.get('comment').setValue("");
            this.deactivationForm.get('comment').setValidators([]);
            this.deactivationForm.get('comment').updateValueAndValidity();
            this.deactivationForm.get('duplicateUserName').setValue("");
            this.deactivationForm.get('duplicateUserName').setValidators([]);
            this.deactivationForm.get('duplicateUserName').updateValueAndValidity();
        }
    }

    closeDeactivationForm() {
        this.isEnabled = false;
        this.isDuplicate = false;
        this.deactivationForm.reset();
        Helpers.closeModal('deactivate_user');
        this.deactivationForm.get('reason').setValue('');
        this.deactivationForm.get('reason').updateValueAndValidity();
        this.deactivationForm.get('duplicateUserName').setValue('');
        this.deactivationForm.get('duplicateUserName').updateValueAndValidity();
        this.deactivationForm.get('comment').setValue('');
        this.deactivationForm.get('comment').updateValueAndValidity();
        this.deactivationForm.get('document').setValue('');
        this.deactivationForm.get('document').updateValueAndValidity();
        this.localFileName.localFile = "";
        this.localFileName.document = "";
        this.deactivateUserProfile = false;
    }

    submitDeactivationRequest() {
        if (this.deactivationForm.valid) {
            const role = this.loggedInUser.role.toLowerCase();
            const formData = this.deactivationForm.getRawValue();
            formData['requestId'] = this.selectedRequest.requestId;
            this.totBatchService.reSubmitDeactivationRequestForTrainer(formData, role).subscribe(res => {
                if (res) {
                    swal({
                        title: 'Success',
                        text: 'Your profile de-activation request has been summited for approval. You can check status on dashboard',
                        type: 'success'
                    });
                    Helpers.closeModal('deactivate_user');
                    this.getCurrentUser();
                    this.getDeactivationRequestStatus();
                }
            })
            console.log(formData);
        } else {
            Helpers.markFormGroupTouched(this.deactivationForm);
            toastr.error('Please fill form data');
        }
    }

    getStatus(request) {
        if (request && request.status) {
            if (request.status === 'Pending') {
                return 'New deactivation Request';
            } else if (request.status === 'Approved') {
                return 'Deactivated';
            } else if (request.status === 'Sent Back') {
                return 'PMU Refer Back';
            } else {
                return request.status
            }
        } else {
            return 'N/A'
        }
    }

    takeAction(request) {
        this.selectedRequest = request;
        swal({
            title: `Are You Sure, You want to deactivate profile.`,
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#d33',
        }).then((action: any) => {
            if (action.value) {
                this.totBatchService.checkBatchLinkageForTrainer().subscribe(res => {
                    if (res) {
                        this.patchFormValues(request);
                        this.deactivateUserProfile = true;
                        Helpers.openModal('deactivate_user');
                    }
                })
            }
        })
    }

    patchFormValues(request) {
        if (request.reason === "duplicate") {
            this.isDuplicate = true;
            this.isEnabled = false;
            this.deactivationForm.get('reason').patchValue(request.reason);
            this.deactivationForm.get('duplicateUserName').patchValue(request.duplicateUserName);
            this.deactivationForm.get('document').patchValue(request.document);
        } else if (request.reason === "notListed") {
            this.isDuplicate = false;
            this.isEnabled = true;
            this.deactivationForm.get('reason').patchValue(request.reason);
            this.deactivationForm.get('comment').patchValue(request.comment);
            this.deactivationForm.get('document').patchValue(request.document);
        } else {
            this.isDuplicate = false;
            this.isEnabled = false;
            this.deactivationForm.get('reason').patchValue(request.reason);
            this.deactivationForm.get('document').patchValue(request.document);
        }
    }

    viewComment(request) {
        this.remarksFromPMU = request.remarksFromPMU;
        if (this.remarksFromPMU.length > 0) {
            Helpers.openModal('view_comment');
        } else {
            toastr.warn('Comments not available');
        }
    }

    closeCommentModal() {
        this.remarksFromPMU = [];
    }

    assignPageNo(pageNo) {
        this.pageNo = pageNo;
        this.getDeactivationRequestStatus();
    }

    assignRecordsPerPage(perPage) {
        this.itemsPerPage = perPage;
        this.getDeactivationRequestStatus();
    }
}
